import type { Author } from 'pkg/api/models/author';
import type { Dateable } from 'pkg/api/models/dateable';

export enum AccountNotificationType {
	ActivityLike = 'user_activity_like',
	ActivityComment = 'user_activity_comment',
	SystemNotification = 'system_notification',
	GroupPostLike = 'group_post_like',
	GroupPostComment = 'group_post_comment',
	EventInvite = 'event_invite',
	AccountInvite = 'account_invite',
	GroupPost = 'group_post',
	GroupVideo = 'group_video',
	VideoSequenceUserTag = 'video_sequence_user_tag',
	VideoSequenceComment = 'video_sequence_comment',
	EventComment = 'event_comment',
	EventSession = 'event_session',
	PendingGroupMember = 'pending_group_member',
	ActiveGroupMember = 'active_group_member',
	PendingGroupMemberAccepted = 'pending_group_member_accepted',
	EventUpdateLocation = 'event_update_location',
	EventUpdateTime = 'event_update_time',
	EventUpdateLocationAndTime = 'event_update_location_time',
	EventDelete = 'event_delete',
	MatchDeclined = 'match_declined',
	EventSeriesInvite = 'event_series_invite',
	EventSeriesUpdateLocation = 'event_series_update_location',
	EventSeriesUpdateTime = 'event_series_update_time',
	EventSeriesUpdateLocationAndTime = 'event_series_update_location_time',
	EventSeriesDelete = 'event_series_delete',
	InviteAcceptedByParent = 'invite_accepted_by_parent',
	InviteDeclinedByParent = 'invite_declined_by_parent',
	InviteAcceptedByChild = 'invite_accepted_by_child',
	InviteDeclinedByChild = 'invite_declined_by_child',
	SeriesInviteAcceptedByParent = 'series_invite_accepted_by_parent',
	SeriesInviteDeclinedByParent = 'series_invite_declined_by_parent',
	SeriesInviteAcceptedByChild = 'series_invite_accepted_by_child',
	SeriesInviteDeclinedByChild = 'series_invite_declined_by_child',
	ReminderMatchInvite = 'reminder_match_invite',
	ReminderMatchInviteParent = 'reminder_match_invite_parent',
	Booking = 'booking_created',
	SchedulePublished = 'schedule_published',
	EventInviteParent = 'event_invite_parent',
	AccountRelationApproval = 'account_relation_approved',
	AccountRelationRequest = 'account_relation_request',
	AccountRelationRequestForOthers = 'account_relation_request_for_others',
	AccountRelationRequestForOthersNotifyGuardian = 'account_relation_request_for_others_notify_guardian',
	AccountRelationRequestNotifyGuardian = 'account_relation_request_notify_guardian',
	AccountRelationApprovalByGuardianNotifyOtherGuardian = 'account_relation_approval_notify_guardian',
	AccountRelationApprovalNotifyWard = 'account_relation_approval_notify_ward',
	AccountRelationApprovalByWardNotifyOtherGuardian = 'account_relation_approval_by_ward_notify_guardian',
	AccountRelationCreatedWard = 'account_relation_created_ward',
	AccountRelationCreatedLegalGuardian = 'account_relation_created_legal_guardian',
	AccountRelationCreatedOtherLegalGuardian = 'account_relation_created_other_legal_guardian',
	BookingUpdated = 'booking_updated',
	AccountRelationRemoved = 'account_relation_removed',
	AccountRelationRemovedByOther = 'account_relation_removed_by_other',
	BookingBulkDeleted = 'booking_bulk_deleted',
	EventCanceled = 'event_canceled',
	EventRepublish = 'event_republish',
	SchedulePublishedFailed = 'schedule_published_failed',
	SchedulePublishedPartiallyFailed = 'schedule_published_partially_failed',
	SchedulePublishedSuccess = 'schedule_published_success',
	EventsUpdatedFromSchedule = 'schedule_events_updated_from_schedule',
	EventsDeletedFromSchedule = 'schedule_events_deleted_from_schedule',
	ScheduleUnpublishedSuccess = 'schedule_unpublish_success',
	ScheduleUnpublishedFailed = 'schedule_unpublish_fail',
	ScheduleUnpublished = 'schedule_unpublished',
	InvoiceSent = 'invoice_sent',
	WardAddedToGroup = 'ward_added_to_group',
	WardConnectedToFromInviteNotifyParents = 'ward_connected_to_from_invite_notify_parents',
	NewParentFromInvite = 'new_parent_from_invite',
	EventSeriesCreated = 'event_series_created',
	EventSeriesCreationFailed = 'event_series_creation_failed',
	EventSeriesUpdated = 'event_series_updated',
	EventSeriesUpdateFailed = 'event_series_update_failed',
	DisputeOpened = 'dispute_opened',
	FormInvite = 'form_invite',
	FormInviteParent = 'form_invite_parent',
	EventReminderNonRespondent = 'event_reminder_non_respondent',
	EventReminderNonRespondentParent = 'event_reminder_non_respondent_parent',
	EventCarpoolJoined = 'event_carpool_joined',
	EventCarpoolRemoved = 'event_carpool_removed',
	EventCarpoolAdded = 'event_carpool_added',
	EventCarpoolPassengerRemoved = 'event_carpool_passenger_removed',
	RefundIssued = 'refund_issued',
	PaymentFailed = 'payment_failed',
	PaymentReminder = 'payment_reminder',
	PaymentReceipt = 'payment_receipt',
	FormEventGroupRemoved = 'form_event_group_removed',
	FormEventGroupEventAdded = 'form_event_group_event_added',
}

export interface AccountNotification extends Dateable {
	id: string;
	userId: number;
	accountId: number;
	authorId: number;
	authorGroupId: number;
	isRead: boolean;
	title: string;
	message: string;
	url: string;
	targetId: number;
	triggerId: number;
	targetType: string;
	type: AccountNotificationType;

	author: Author;
	target: any;
}
